import { Box, IconButton, styled, Typography } from '@mui/material';
import { Card } from '@sb/cc-design-system';

export const CHANNEL_CARD_DESIGN = {
  borderRadius: 24,
  backgroundColor: '#FFFFFF',
  boxShadow: 'none',
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
};

export const ChannelCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.brand.cardSurface}`,
  borderRadius: '24px',
  overflow: 'hidden',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const ChannelPreview = styled(Box)(({ theme }) => ({
  height: '138px',
  background: theme.palette.brand.cardSurface,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ChannelPreviewImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const ChannelFooter = styled(Box)`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  min-height: 62px;
`;

export const ChannelNameWrapper = styled(Box)`
  flex: 1 1 auto;
  min-width: 0;
`;

export const ChannelName = styled(Typography)`
  font-size: 14px;
  font-weight: 700;
  color: #191b23;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChannelActions = styled(Box)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
`;

export const ChannelActionIconButton = styled(IconButton)`
  color: #6b7280;
  font-size: 20px;
`;
